import React, { useState } from "react";
import Shield from "../ThreatModeling/images/shield.png";
import { useTheme } from "../ThemeContext";
import styled from "@emotion/styled";
import "./LoginForm.css";
import { signInWithSSO } from "../../services/Auth/auth";

const Title = styled.h1`
  font-size: 26px;
  font-weight: 200;
  margin-bottom: 40px;
`;

// Microsoft/Entra ID icon component
const MicrosoftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
    <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
    <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
  </svg>
);

const LoginForm = ({ onSignInSuccess }) => {
  const { isDark } = useTheme();
  const [error, setError] = useState("");
  const [ssoLoading, setSsoLoading] = useState(false);

  // Handle SSO login with Entra ID
  const handleSSOLogin = async () => {
    setSsoLoading(true);
    setError("");
    try {
      await signInWithSSO();
      // Note: This will redirect to Entra ID, so the code below won't execute
      // The user will be redirected back after authentication
    } catch (error) {
      console.error("SSO login error:", error);
      setError(error.message || "Error initiating SSO login");
      setSsoLoading(false);
    }
  };

  return (
    <div className={`login-container ${isDark ? "dark-theme" : "light-theme"}`}>
      <div className="form-container">
        <img src={Shield} alt="Threat Designer logo" style={{ width: "80px" }} />
        <Title>Welcome back</Title>
        {error && <div className="error-message">{error}</div>}
        
        <button
          type="button"
          className={`sso-button ${isDark ? "dark" : "light"}`}
          onClick={handleSSOLogin}
          disabled={ssoLoading}
        >
          {ssoLoading ? (
            <span className="sso-loading">Redirecting...</span>
          ) : (
            <>
              <MicrosoftIcon />
              <span>Sign in with TUI Account</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default LoginForm;
